var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.948647176,1.33517342 C0.977008558,0.597777501 1.5956951,0 2.33517342,0 L8.33149325,0 C9.06888917,0 9.68957802,0.595695098 9.71801949,1.33517342 L9.94864718,7.33149325 C9.97700856,8.06888917 9.55254038,9.05020348 8.98740284,9.53460709 L6.84846627,11.3679813 C6.01168145,12.0852254 4.65475993,12.0850323 3.8182004,11.3679813 L1.67926383,9.53460709 C1.12002186,9.05525683 0.689578017,8.07097157 0.71801949,7.33149325 L0.948647176,1.33517342 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0C47B7",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E53B35",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1693",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.666667, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 1.33333333,
    d: "M8.33149325,-0.666666667 C8.87774684,-0.666666667 9.38169171,-0.447528048 9.7535726,-0.0894205237 C10.1247853,0.268043584 10.3631608,0.762698969 10.3841936,1.30955134 L10.3841936,1.30955134 L10.6148213,7.30587117 C10.6500315,8.22133547 10.1228128,9.43945045 9.42126375,10.0407782 L9.42126375,10.0407782 L7.28232718,11.8741524 C6.74416154,12.3354372 6.04028832,12.5725086 5.3333596,12.5725086 C4.62633991,12.5725086 3.92242852,12.3353715 3.38433948,11.8741524 L3.38433948,11.8741524 L1.24540291,10.0407782 C0.551172549,9.44572356 0.016535775,8.22392074 0.051845374,7.30587117 L0.051845374,7.30587117 L0.28247306,1.30955134 C0.303473754,0.763533298 0.541638854,0.268277084 0.913343916,-0.0896611237 C1.28473227,-0.447294354 1.78808505,-0.666666667 2.33517342,-0.666666667 L2.33517342,-0.666666667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,6.99365234 C4.66666667,6.81306314 4.50973002,6.66666667 4.33640734,6.66666667 L2.99692599,6.66666667 C2.8145288,6.66666667 2.66666667,6.52397664 2.66666667,6.33021037 L2.66666667,5.66978963 C2.66666667,5.48396995 2.82360331,5.33333333 2.99692599,5.33333333 L4.33640734,5.33333333 C4.51880453,5.33333333 4.66666667,5.19064331 4.66666667,4.99687703 L4.66666667,4.3364563 C4.66666667,4.15063662 4.52397664,4 4.33021037,4 L3.66978963,4 C3.48396995,4 3.33333333,3.85730998 3.33333333,3.6635437 L3.33333333,3.00312297 C3.33333333,2.81730328 3.47602336,2.66666667 3.66978963,2.66666667 L4.33021037,2.66666667 C4.51603005,2.66666667 4.66666667,2.52397664 4.66666667,2.33021037 L4.66666667,1.66978963 C4.66666667,1.48396995 4.80935669,1.33333333 5.00312297,1.33333333 L5.6635437,1.33333333 C5.84936338,1.33333333 6,1.47602336 6,1.66978963 L6,2.33021037 C6,2.51603005 6.14269002,2.66666667 6.3364563,2.66666667 L6.99687703,2.66666667 C7.18269672,2.66666667 7.33333333,2.80935669 7.33333333,3.00312297 L7.33333333,3.6635437 C7.33333333,3.84936338 7.19064331,4 6.99687703,4 L6.3364563,4 C6.15063662,4 6,4.14269002 6,4.3364563 L6,4.99687703 C6,5.18269672 6.15693665,5.33333333 6.33025932,5.33333333 L7.66974068,5.33333333 C7.85213786,5.33333333 8,5.47602336 8,5.66978963 L8,6.33021037 C8,6.51603005 7.84306335,6.66666667 7.66974068,6.66666667 L6.33025932,6.66666667 C6.14786214,6.66666667 6,6.81003825 6,6.99365234 L6,9.00634766 C6,9.18693686 5.85730998,9.33333333 5.6635437,9.33333333 L5.00312297,9.33333333 C4.81730328,9.33333333 4.66666667,9.18996175 4.66666667,9.00634766 L4.66666667,6.99365234 Z",
    id: "Rectangle-1694",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,8.66666667 C5.86405742,8.66666667 6.32235829,8.9767473 6.53695132,9.42562394 C8.15807394,9.68096925 9.33333333,10.4385272 9.33333333,11.3333333 C9.33333333,12.4379028 7.54247233,13.3333333 5.33333333,13.3333333 C3.12419433,13.3333333 1.33333333,12.4379028 1.33333333,11.3333333 C1.33333333,10.4385272 2.50859273,9.68096925 4.12940807,9.42551133 C4.34430838,8.9767473 4.80260925,8.66666667 5.33333333,8.66666667 Z",
    id: "Oval-215",
    stroke: "none",
    fill: "#1251A1",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.aba644f203f6b6892b6ddbae46f2d7ce.svg";
export { ForwardRef as ReactComponent };